// extracted by mini-css-extract-plugin
export default {"message":"InputMessage_message__v54pk","message--state-alert":"InputMessage_message--state-alert__lhPH6","message--state-success":"InputMessage_message--state-success__Qs9tx"};